export default "__VITE_ASSET__8f85b660__"